<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Warehouse Mapping</p>
          </div>
        </div>
      </div>
    </section>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      name="SaveWowKitMapping"
    >
      <card-component>
        <template>
          <div class="columns is-mobile">
            <div class="column">
              <div class="content">
                <b> .csv file must contain<br /></b>
                <ul>
                  <li>Franchisee ID: Use proper franchisee id</li>
                  <li>Warehouse ID: Use proper warehouse id</li>
                  <li>PO Type</li>
                  <li>KIT Type</li>
                  <li>Priority</li>
                  <!-- <li>Date Format: DD/MM/YYYY</li>
                  <li>Franchisee Name: Use proper franchisee name</li> -->
                </ul>
              </div>
            </div>
            <div class="column">
              <section class="text-is-centered">
                <b-field>
                  <b-upload
                    v-model="dropFiles"
                    @input="csvToJsonInput(dropFiles)"
                    accept=".csv"
                    single
                    drag-drop
                    title="Please do upload .csv file only"
                  >
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <div v-show="flag">
                  <span v-if="dropFiles" class="tag is-primary">
                    {{ dropFiles.name }}
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteDropFile()"
                    ></button>
                  </span>
                </div>
              </section>
            </div>
            <div class="column has-text-centered">
              <a
                class="button is-link"
                href="https://intellitots.s3.ap-south-1.amazonaws.com/franchiseeWarehouseMapping.csv"
                download
                >Download dummy file</a
              >
            </div>
          </div>
          <footer class="column has-text-centered">
            <button class="button is-success" type="submit">Save</button>
          </footer>
        </template>
        <div class="columns is-mobile">
          <div
            class="column"
            v-if="isResponse"
            style="display: inline-block; margin-right: 5%"
          >
            <b-button class="has-text-left" outlined type="is-success"
              >Success: {{ count.success }} </b-button
            >&nbsp;
            <b-button class="button has-text-centered" outlined type="is-info"
              >Already Exist: {{ count.alreadyExist }}</b-button
            >&nbsp;
            <b-button class="button has-text-right" outlined type="is-danger"
              >Failure: {{ count.failure }}</b-button
            >
          </div>
        </div>
        <div class="columns is-mobile">
          <div
            class="column"
            v-if="jsonData.length > 0"
            style="overflow-x: scroll"
          >
            <table>
              <thead>
                <th
                  class="text-is-centered"
                  v-for="head in Object.keys(jsonData[0])"
                  v-bind:class="classIsValid(head)"
                  :key="head"
                >
                  {{ head }}
                </th>
              </thead>
              <tbody>
                <tr v-for="(row, index) in jsonData" :key="index">
                  <td
                    v-for="(data, head) in row"
                    v-bind:class="classIsValid(head, row)"
                    :key="head"
                  >
                    {{ data ? data.toString() : '-' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </card-component>
    </form>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
// import csvjson from 'csvjson'
import csvtojsonV2 from 'csvtojson'

export default {
  name: 'uploadEnquiries',
  components: {
    CardComponent
  },

  data () {
    return {
      jsonData: [],
      flag: false,
      dropFiles: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      fileinput: '',
      isResponse: false,
      count: {
        success: 0,
        failure: 0,
        alreadyExist: 0
      },
      colorCode: [],
      headers: [],
      uploadedData: []
    }
  },
  created: function () {
    this.onStart()
  },
  methods: {
    onStart: async function () {
      this.isResponse = false
    },
    classIsValid (key, data) {
      return {
        hidden: key === 'statusCode',
        statusCode: key === 'status',
        'success-text': key === 'status' && data && data.statusCode === 200,
        'danger-text': key === 'status' && data && data.statusCode === 99,
        'warning-text': key === 'status' && data && data.statusCode === 98
      }
    },
    readerFile: function (file, onLoadCallback) {
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function () {
      if (this.dropFiles !== null) {
        this.loadingComponent = this.$buefy.loading.open()
        this.isResponse = false
        this.headers = []
        let self = this
        if (this.dropFiles.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = this.dropFiles
        this.readerFile(file, async (e) => {
          try {
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
          } catch (e) {
            self.jsonData = 'this is not running'
          }

          if (!self.jsonData[0].franchiseeID) {
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: 'Invalid format',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } else {
          }

          self.jsonData.forEach((Obj) => {})
          this.headers = Object.keys(self.jsonData[0])
        })
        this.flag = true
        this.loadingComponent.close()
      } else {
        this.dropFiles = []
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please select valid file!',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    async onSubmit (event) {
      this.loadingComponent = this.$buefy.loading.open()
      let that = this
      this.loader = true
      try {
        if (that.dropFiles.length < 1) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please upload file to save Mapping!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let isError = false
        that.jsonData.forEach((obj) => {
          if (
            !obj.franchiseeID ||
            !obj.warehouseID ||
            !obj.poType ||
            !obj.priority ||
            !obj.kitType
          ) {
            isError = true
          }
          if (obj.kitType && typeof obj.kitType !== 'string') {
            isError = true
          }
        })
        if (isError) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Invalid data-some required fields are empty ',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.count = {
          success: 0,
          failure: 0,
          alreadyExist: 0
        }
        let length = that.jsonData.length
        let data = []
        let i = 0

        while (i < length) {
          let endIndex = length > i + 50 ? i + 50 : i + length - i

          let array = that.jsonData.slice(i, endIndex)
          i = i + 50
          let response = await http.post(
            `${constants.API_URL}/api/warehouseMapping/bulk-create`,
            { data: array }
          )
          if (response && response.data) {
            this.count = {
              success: this.count.success + response.data.count.success,
              failure: this.count.failure + response.data.count.failure,
              alreadyExist:
                this.count.alreadyExist + response.data.count.alreadyExist
            }
            data.push(...response.data.response)
          }
        }

        if (data) {
          this.isResponse = true
          that.jsonData = data
          this.headers.push('Status')
        }
        this.loader = false
        this.loadingComponent.close()
        this.dropFiles = []
        this.uploadDialog = false
        this.flag = false
        let message = `Uploading Status:-\r\n
        Succeed: ${this.count.success} \nFailed: ${this.count.failure} \nAlready Exist: ${this.count.alreadyExist}`
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: message,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        this.dropFiles = []
        this.uploadDialog = false
        this.flag = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error while uploading file', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    deleteDropFile () {
      this.isResponse = false
      this.flag = false
      this.dropFiles = []
      this.jsonData = []
      this.headers = []
    }
  }
}
</script>
<style scoped>
table {
  width: 80% !important;
  border-collapse: collapse;
  border: 1px solid black;
  padding: 0.65rem 0.7rem;
  font-size: 1rem;
}
th,
td {
  /* width: 100%; */
  border-collapse: collapse;
  border: 1px solid black;
  padding: 0.65rem 0.7rem;
  font-size: 1rem;
}
table {
  overflow-x: scroll;
  overflow-y: scroll;
}
td {
  display: table-cell;
  padding: 5px;
  color: black;
}
th {
  color: #fff;
  background-color: #56509f;
}
.hidden {
  display: none;
}
.statusCode {
  font-style: italic;
  font-weight: 600;
}
</style>
